<template>
  <v-card max-width="200">
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          class="pa-0"
        >
          <v-select
            v-model="localValue.source"
            :items="advertExternalSource"
            label="источник"
            item-value="id"
            item-text="value"
            class="pa-2"
            hide-details
          ></v-select>
        </v-col>
        <v-col
          cols="12"
          class="pa-0"
        >
          <v-textarea
            outlined
            v-model="localValue.source_id"
            label="id источника"
            class="pa-2"
            hide-details
            rows="1"
          ></v-textarea>
        </v-col>
        <v-col
          cols="12"
          class="pa-0"
        >
          <v-textarea
            outlined
            v-model="localValue.source_link"
            label="Ссылка на источник"
            class="pa-2"
            hide-details
            rows="1"
          ></v-textarea>
        </v-col>
        <v-col
          cols="12"
          class="pa-0 text-right"
        >
          <v-btn
            color="primary"
            dark
            x-small
            @click="handleSave"
            class="mr-1"
          >
            {{$t('base.save')}}
          </v-btn>
          <v-btn
            x-small
            @click="$emit('close')"
          >
            {{$t('base.cancel')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { cleanClone } from '@/components/utils/common'

export default {
  name: 'AdvertExternalDetail',
  props: {
    value: Object
  },
  computed: {
    advertExternalSource () {
      return this.$store.getters['serviceData/optionsList']('advertExternalIds.source', false)
    }
  },
  data () {
    return {
      localValue: cleanClone(this.value)
    }
  },
  watch: {
    value: {
      handler () {
        this.localValue = cleanClone(this.value)
      },
      deep: true
    }
  },
  methods: {
    handleSave () {
      this.$emit('change', this.localValue)
      this.localValue = cleanClone(this.value)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
